<template>
  <div>
    <DataTableServer
      v-if="items"
      @click:row="handleRowClick"
      :headers="tableHeaders"
      :hide-default-footer="!totalItemCount"
      :hover="canOpenInvoices"
      :items="items"
      :items-length="totalItemCount"
      :items-per-page="100"
      :loading="processing"
      :row-props="{
        class: {
          'cursor-default': !canOpenInvoices,
        },
      }"
      class="b-radius-0 b-1 bc-outlined-gray"
      item-key="id"
      no-data-text="No invoices found"
      fixed-header
      return-object
    >
      <template #[`item.id`]="{ item }">
        {{ shortId(item.id) }}
      </template>

      <template #[`item.application_name`]="{ item }">
        <router-link
          v-if="item.application_id && item.application_type"
          @click.stop.prevent
          :to="{
            name: item.application_type == 'Subsidy' ? 'SubsidyShow' : 'GrantShow',
            params: { id: item.application_id },
            query: { tab: 'Funding' },
          }"
        >
          {{ item.application_name }}
        </router-link>

        <span v-else>
          {{ item.application_name }}
        </span>
      </template>

      <template #[`item.start_date`]="{ item }">
        <LongDate :date="item.start_date" />
      </template>

      <template #[`item.status`]="{ item }">
        <StandardChip
          v-bind="getInvoiceStatusPresentation(item.status)"
          :text="getStatusDisplayValue(item.status)"
          role="status"
        />
      </template>

      <template #[`item.total_amount`]="{ item }">
        <span>
          {{ currency(item.total_amount) }}
        </span>
      </template>
    </DataTableServer>

    <InvoiceEditor
      v-if="canOpenInvoices"
      ref="invoiceEditor"
    />
  </div>
</template>

<script setup>
import { currency, shortId } from '@/plugins/filters';
import DataTableServer from '@/shared/components/table/DataTableServer.vue';
import { getInvoiceStatusPresentation, getStatusDisplayValue } from '@/shared/utils/invoiceStatus';
import InvoiceEditor from '@/specialist/components/invoice/InvoiceEditor.vue';
import LongDate from '@/shared/components/LongDate.vue';

const props = defineProps({
  canOpenInvoices: Boolean,
  defaultProviders: {
    type: Array,
    default: () => null,
  },
  statement: {
    type: Object,
    default: () => {},
  },
});

const items = ref(null);
const processing = ref(null);
const tableHeaders = ref([
  {
    title: 'Invoice ID',
    value: 'id',
  },
  {
    title: 'Child',
    value: 'application_name',
  },
  {
    title: 'Date',
    value: 'start_date',
  },
  {
    title: 'Status',
    value: 'status',
    align: 'center',
  },
  {
    title: 'Amount',
    value: 'total_amount',
    align: 'end',
  },
]);
const totalItemCount = ref(null);
const invoiceEditor = ref(null);

function handleRowClick(_event, { item }) {
  if (props.canOpenInvoices) openInvoice(item.id);
}

async function load() {
  items.value = props.statement.invoices;
  totalItemCount.value = items.value.length;
}

function openInvoice(invoiceId) {
  invoiceEditor.value.open(invoiceId);
}

onMounted(load);
</script>
